import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Show the notification with animation
    this.element.classList.remove('opacity-0', 'translate-x-full');
    this.element.classList.add('opacity-100', 'translate-x-0');

    // Auto-hide after 5 seconds
    this.timeout = setTimeout(() => {
      this.hide();
    }, 5000);
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  dismiss(event) {
    event?.preventDefault();
    this.hide();
  }

  hide() {
    // Animate out
    this.element.classList.remove('opacity-100', 'translate-x-0');
    this.element.classList.add('opacity-0', 'translate-x-full');
    
    // Remove from DOM after animation
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }
}
